module.exports = __webpack_public_path__ + "static/img/equipamiento-six-1.f121442.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/equipamiento-six-1.jpg
// module id = v7XO
// module chunks = 1